class VariantSelectsCustom extends HTMLElement {
  constructor() {
    super()

    /** @type {HTMLInputElement[]} */
    this.inputs = []

    /** @type {HTMLButtonElement | null} */
    this.productFormCustom = null

    /** @type {HTMLProductInfoCustomElement | null} */
    this.productInfoCustom = null

    /** @type {string | null} */
    this.selectedVariantId = null

    this.variantIdInput = null
  }

  connectedCallback() {
    this.setStaticElements()
    this.setVariantId()
    this.setInputListeners()
  }

  setInputs(inputs) {
    this.inputs = inputs
  }

  setProductInfoCustom(productInfoCustom) {
    this.productInfoCustom = productInfoCustom
  }

  setProductFormCustom(productFormCustom) {
    this.productFormCustom = productFormCustom
  }

  setVariantIdInput(variantIdInput) {
    this.variantIdInput = variantIdInput
  }

  setStaticElements() {
    const inputs = this.querySelectorAll('input[type="radio"]')
    if (inputs.length > 0) {
      this.setInputs(inputs)
    }

    const productInfoCustom = this.closest('product-info-custom')
    if (productInfoCustom) {
      this.setProductInfoCustom(productInfoCustom)
    }

    const productFormCustom = this.querySelector('product-form-custom')
    if (productFormCustom) {
      this.setProductFormCustom(productFormCustom)
    }

    const variantIdInput = this.querySelector('input[type="hidden"][name="id"]')
    if (variantIdInput) {
      this.setVariantIdInput(variantIdInput)
    }
  }

  setVariantId() {
    this.checkedInput = this.querySelector('input[type="radio"]:checked')
    if (this.checkedInput) {
      this.variantIdInput.value = this.checkedInput.dataset.variantId
      this.selectedVariantId = this.checkedInput.dataset.variantId
    }
  }
  setInputListeners() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleInputChange.bind(this))
    })
  }

  handleInputChange(event) {
    if (event.target.checked) {
      this.setVariantId()
      this.productFormCustom.updateBaseProductSubTotal(this.selectedVariantId)
    }
  }

  animateClose(milliseconds) {
    const contentContainer = this.querySelector('[data-component-variant-selects-custom-content-container]')
    if (!contentContainer) return

    const contentHeight = contentContainer.scrollHeight

    // Set the height to the current content height
    contentContainer.style.height = `${contentHeight}px`
    contentContainer.style.transition = `height ${milliseconds}ms ease`

    requestAnimationFrame(() => {
      // Transition to height 0
      contentContainer.style.height = `0px`
    })

    // Cleanup after the transition ends
    contentContainer.addEventListener(
      'transitionend',
      () => {
        contentContainer.style.transition = '' // Remove inline transition
        contentContainer.style.height = '' // Reset height
      },
      { once: true }
    )
  }

  animateOpen(milliseconds) {
    const contentContainer = this.querySelector('[data-component-variant-selects-custom-content-container]')
    if (!contentContainer) return

    contentContainer.style.height = `0px`
    contentContainer.style.overflow = 'hidden'
    contentContainer.style.transition = `height ${milliseconds}ms ease`

    const contentHeight = contentContainer.scrollHeight

    requestAnimationFrame(() => {
      contentContainer.style.height = `${contentHeight}px`
    })

    // Cleanup after the transition ends
    contentContainer.addEventListener(
      'transitionend',
      () => {
        contentContainer.style.height = 'auto'
        contentContainer.style.transition = ''
        contentContainer.style.overflow = ''
      },
      { once: true }
    )
  }
}

customElements.define('variant-selects-custom', VariantSelectsCustom)
